module.exports = __webpack_public_path__ + "img/content9.baff98eb.png";